<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent max-width="1500">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <span class="subheadline">Informe/Auditoria Nuevo</span>
          <v-layout row wrap class="item-group">
            <v-flex>
              <v-autocomplete
                v-model="report"
                label="Tipo de Informe a Crear"
                required
                :error-messages="getRequiredErrors('report')"
                :items="reports"
                @change="fillTorneos"
                item-text="description"
                item-value="pk"
              ></v-autocomplete>
           <!--   <v-text-field
                v-model="descripcion"
                label="Nombre de Informe"
                placeholder=""
                required
                :error-messages="getRequiredErrors('descripcion')"
                @input="onDescriptionChange"
              ></v-text-field>-->
              <v-autocomplete
                v-model="torneo"
                label="Torneo"
                required
                @change="fillFechas"
                :error-messages="getRequiredErrors('torneo')"
                :items="torneos"
                item-text="description"
                item-value="id"
              ></v-autocomplete>
              <v-autocomplete
                v-model="fecha"
                label="Fecha"
                required
                @change="fillPartidos"
                :error-messages="getRequiredErrors('fecha')"
                :items="fechas"
                item-text="nombreCompleto"
                item-value="id"
              ></v-autocomplete>
              <v-autocomplete
                v-model="partido"
                label="Partido"
                required
                :error-messages="getRequiredErrors('partido')"
                :items="partidos"
                item-text="description"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-btn color="primary" @click="closeDialog">Volver</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submit">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../../mixins/createEntityMixin'

export default {
  mixins: [validationMixin, createEntityMixin],

  validations: {
    report: { required },
    // descripcion: { required },
    torneo: { required },
    fecha: { required },
    partido: { required }
  },

  components: {},

  data () {
    return {
      dialog: false,
      createPath: 'informe-auditoria/create',
      isEditing: false,
      definicionPresentacion: null,
      reports: [],
      report: null,
      descripcion: null,
      torneos: [],
      torneo: null,
      fechas: [],
      fecha: null,
      partidos: [],
      partido: null
    }
  },
  methods: {
    fetchDefiniciones () {
      this.axios
        .get('informe-auditoria/report-tournament')
        .then(response => {
          const reportesMapeados = response.data.map((reportTournament) => {
            return { pk: reportTournament['reportId'], description: reportTournament['reportDescription'] }
          })
          this.reports = reportesMapeados
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    isValidForm () {
      return !this.$v.$invalid
    },
    getPayload () {
      return {
        report: this.report,
        description: this.descripcion,
        type: 2,
        partido: this.partido
      }
    },
    showDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },
    onDescriptionChange (event) {
      this.descripcion = event
    },
    fetchTorneos () {
      this.axios
        .get('informe-auditoria/report-tournament')
        .then(response => {
          const torneosMapeados = response.data.map((reportTournament) => {
            return { id: reportTournament['tournamentId'], description: reportTournament['tournamentDescription'] }
          })
          this.torneos = torneosMapeados
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fillFechas (event) {
      this.fetchFechasByIdTorneo(event)
      this.fecha = null
      this.partido = null
    },
    fetchFechasByIdTorneo (id) {
      this.loading = true
      this.axios
        .get(`informe-auditoria/fechas`, {
          params: {
            torneo: id
          }
        })
        .then(response => {
          this.fechas = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fillPartidos (event) {
      this.fetchPartidosByIdFecha(event)
      this.partido = null
    },
    fetchPartidosByIdFecha (idFecha) {
      this.loading = true
      this.axios
        .get(`informe-auditoria/partidos`, {
          params: {
            fecha: idFecha
          }
        })
        .then(response => {
          this.partidos = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    postSuccessfulSubmit () {
      this.goBack()
      this.saving = false
    },
    goBack () {
      this.goBackConfirmed = true
      this.$router.go()
    },
    fillTorneos (event) {
      this.fetchTorneosByIdReporte(event)
      this.torneo = null
      this.partido = null
      this.fecha = null
    },
    fetchTorneosByIdReporte (idReporte) {
      this.axios
        .get(`informe-auditoria/report-tournament?report=${idReporte}`)
        .then(response => {
          this.torneos = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    }
  },
  created () {
    this.fetchDefiniciones()
  }
}
</script>

<style>
.subheadline {
  color: lightslategray;
  font-size: 1.6em;
  color: rgb(60, 145, 197);
  padding-top: 1.5em;
  margin-top: 2em;
}
</style>
